import { PROJECTS } from "../../data/portfolio";
import { Lines, Reveal } from "../motion";
import { Cta, Eyebrow } from "../ui-bits";
import { ProjectCard } from "../ProjectCard";

const LAYOUT = [
  "md:col-span-7",
  "md:col-span-4 md:col-start-9 md:mt-48",
  "md:col-span-5 md:col-start-2",
  "md:col-span-6 md:col-start-7 md:mt-32",
];
const ASPECT = ["aspect-[4/5]", "aspect-[3/4]", "aspect-[4/5]", "aspect-[5/4]"];

export const SelectedWork = () => (
  <section className="bg-white/60 px-5 py-24 sm:px-10 md:py-36 lg:px-16" data-testid="home-work">
    <div className="grid grid-cols-12 items-end gap-y-8 lg:gap-x-10">
      <div className="col-span-12 lg:col-span-3"><Reveal><Eyebrow n="03">Progetti selezionati</Eyebrow></Reveal></div>
      <div className="col-span-12 lg:col-span-6">
        <Lines lines={["Lavori che raccontano", "più di un post."]} className="text-4xl leading-[1.1] sm:text-5xl lg:text-6xl" />
      </div>
      <Reveal className="col-span-12 lg:col-span-3 lg:justify-self-end"><Cta to="/progetti" variant="outline" testid="home-work-all">Tutti i progetti</Cta></Reveal>
    </div>
    <div className="mt-16 grid grid-cols-12 gap-y-16 md:mt-24 md:gap-x-10">
      {PROJECTS.filter((p) => p.home).slice(0, 4).map((p, i) => (
        <Reveal key={p.slug} className={`col-span-12 ${LAYOUT[i]}`} delay={(i % 2) * 0.1}>
          <ProjectCard p={p} aspect={ASPECT[i]} index={i} />
        </Reveal>
      ))}
    </div>
  </section>
);
